export default {
    path: '/institutionList',
    name: "InstitutionList",
    component: () => import(/* webpackChunkName: "abuout" */ '../../views/institution/institutionList.vue')
}